import { FC } from 'react';

import {
  BUTTON_TYPES,
  MIME_TYPES,
  NOTIFICATION_TYPES,
} from '@savgroup-front-common/constants';

import {
  FileAttachmentUploadLink,
  SessionType,
} from '../../../../../api/Attachment/getFilesUploadLinksBySessionIdCommand';
import ActionRow from '../../../../../atoms/ActionRow/ActionRow';
import { Banner } from '../../../../../atoms/Banners';
import Button from '../../../../../atoms/button/Button';
import Didactic from '../../../../../atoms/Didactic/Didactic';
import FormGroup from '../../../../../atoms/Form/FormGroup';
import Heading from '../../../../../atoms/Heading/Heading';
import { SafeFormattedMessageWithoutSpread } from '../../../../../formatters';
import { useIsSuperAdmin } from '../../../../../hooks';
import { useQrCodeImportModal } from '../QrCodeImportModal.hooks';

import messages from './messages';

interface QrCodeImportProps {
  additionalInformationId: string;
  claimId: string;
  onUploadFinishClick: () => void;
  isSubmitLoading: boolean;
  onCreateUploadSession: (
    fileAttachmentUploadLink: FileAttachmentUploadLink,
  ) => void;
  allowedMimeTypes?: MIME_TYPES[];
  sessionType: SessionType;
}

export const QrCodeImportModalContent: FC<QrCodeImportProps> = ({
  additionalInformationId,
  claimId,
  onUploadFinishClick,
  isSubmitLoading,
  onCreateUploadSession,
  allowedMimeTypes,
  sessionType,
}) => {
  const isSuperAdmin = useIsSuperAdmin();

  const { uploadQrCode, uploadUrl } = useQrCodeImportModal({
    onSuccess: onCreateUploadSession,
    additionalInformationId,
    claimId,
    allowedMimeTypes,
    sessionType,
  });

  if (!uploadQrCode) {
    return (
      <>
        <Banner notificationType={NOTIFICATION_TYPES.ERROR}>
          <SafeFormattedMessageWithoutSpread
            message={messages.notAbleToOpenUploadSession}
          />
        </Banner>

        <ActionRow>
          <Button
            success
            onClick={onUploadFinishClick}
            type={BUTTON_TYPES.BUTTON}
            isLoading={isSubmitLoading}
            dataTestId="uploadFinishButton"
            small
          >
            <SafeFormattedMessageWithoutSpread
              message={messages.uploadFinish}
            />
          </Button>
        </ActionRow>
      </>
    );
  }

  return (
    <>
      <Heading level={3}>
        <SafeFormattedMessageWithoutSpread message={messages.title} />
      </Heading>
      <Didactic>
        <SafeFormattedMessageWithoutSpread message={messages.didactic} />
      </Didactic>

      <FormGroup>
        <img alt="qrcode" src={`data:${uploadQrCode}`} />
      </FormGroup>

      {isSuperAdmin && uploadUrl && (
        <FormGroup>
          <a href={uploadUrl} target="_blank" rel="noreferrer">
            {uploadUrl}
          </a>
        </FormGroup>
      )}

      <ActionRow>
        <Button
          success
          small
          onClick={onUploadFinishClick}
          type={BUTTON_TYPES.BUTTON}
          isLoading={isSubmitLoading}
          dataTestId="uploadFinishButton"
        >
          <SafeFormattedMessageWithoutSpread message={messages.uploadFinish} />
        </Button>
      </ActionRow>
    </>
  );
};
